import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Utils from 'frilans-finans/utils/utils';

export class InvoiceDetailsRewards extends React.Component {

  static propTypes = {
    invoice: PropTypes.object
  };

  constructor () {
    super();

    this.pointsStatus = this.pointsStatus.bind(this);
  }

  pointsStatus () {
    if (this.props.invoice.paymentStatus === 2) {
      return <Translate content='INVOICE_REWARDS_REGISTERED' />;
    }
    return <Translate content='INVOICE_REWARDS_WAITING_ON_PAYMENT' />;
  }

  isPreReported (invoice) {
    return invoice.preReport || (invoice.preReportedAt && !!Date.parse(invoice.preReportedAt));
  }

  render () {
    let invoice = this.props.invoice;
    if (invoice) {
      return (<div className='invoice-details-part-container'>
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_TOGETHER_REWARDS' />
        <div className='invoice-details-row-container'>
          <div className='invoice-details-row-column padding'>
            <div className='invoice-details-title hide-until-mobile'></div>
            <div className='invoice-details-row'>
              <b><Translate content='INVOICE_DETAILS_REWARDS_ORDER_NUMBER' />: </b>
              {invoice.id}
            </div>
            <div className='invoice-details-row'>
              <b><Translate content='INVOICE_DETAILS_REWARDS_POINTS' />: </b>
              {Utils.numberWithSpaces(Utils.floor(invoice.loyaltyPoints))}
            </div>
          </div>
          <div className='invoice-details-column-divider small'></div>
          <div className='invoice-details-row-column padding'>
            <div className='invoice-details-row'>
              <b><Translate content='INVOICE_DETAILS_REWARDS_REGISTERED_ASSIGNMENT' />: </b>
              {this.isPreReported(invoice)
                ? <Translate content='YES' />
                : <Translate content='NO' />}
            </div>
            <div className='invoice-details-row'>
              <b><Translate content='INVOICE_DETAILS_REWARDS_STATUS' />: </b> {this.pointsStatus()}
            </div>
          </div>
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsRewards;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/rewards.js
 **/